module.exports = __webpack_public_path__ + "static/media/swab-instruction-step06.12651759.png";